import { useState } from "react";

import Valkyrie, { viPause, viPlay } from "@sippy-platform/valkyrie";

import { Button } from "@mui/material";
import PropTypes from "prop-types";

function PlayControl({ audio, activePlayer, setActivePlayer, audioRef }) {
  const [isPlaying, setIsPlaying] = useState(false);

  const togglePlayState = async () => {
    if (activePlayer.id !== audio.id) {
      await setActivePlayer(audio);
      audioRef.current.play();
      setIsPlaying(true);
    } else {
      if (audioRef.current.paused) {
        audioRef.current.play();
        setIsPlaying(true);
      } else {
        audioRef.current.pause();
        setIsPlaying(false);
      }
    }
  };

  if (!audio?.token) {
    return null;
  }

  return (
    <Button
      aria-label="Play"
      onClick={(event) => {
        event.stopPropagation();
        togglePlayState();
      }}
      size="small"
      sx={{ my: -0.5, mr: 1, color: "inherit" }}
    >
      {activePlayer.id === audio.id && isPlaying ? (
        <Valkyrie icon={viPause} size="xs" />
      ) : (
        <Valkyrie icon={viPlay} size="xs" />
      )}
    </Button>
  );
}

PlayControl.propTypes = {
  audio: PropTypes.object,
  activePlayer: PropTypes.object,
  setActivePlayer: PropTypes.func,
  audioRef: PropTypes.object,
};

export default PlayControl;
